import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';

import { CreateConsultantIndustriesApiPayload } from '@/actions/consultant-industries/createConsultantIndustries';
import { updateConsultantIndustries } from '@/actions/consultant-industries/updateConsultantIndustries';
import { ConsultantIndustries } from '@/types/consultant.type';
import { ApiResponse } from '@/types/response.type';

export interface UseUpdateConsultantIndustriesReturn {
  mutate: (
    payload: CreateConsultantIndustriesApiPayload
  ) => Promise<ApiResponse<ConsultantIndustries> | undefined>;
  result: ApiResponse<ConsultantIndustries> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
}

export const useUpdateConsultantIndustries =
  (): UseUpdateConsultantIndustriesReturn => {
    const queryClient = useQueryClient();

    const mutation: UseMutationResult<
      ApiResponse<ConsultantIndustries> | undefined,
      Error,
      CreateConsultantIndustriesApiPayload
    > = useMutation({
      mutationFn: updateConsultantIndustries,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['consultant-industries'] });
      },
    });

    return {
      mutate: mutation.mutateAsync,
      result: mutation.data,
      error: mutation.error,
      isError: mutation.isError,
      isSuccess: mutation.isSuccess,
      isLoading: mutation.isPending,
    };
  };
